import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, ArrowRight } from 'lucide-react';
import { businessConfig, trackPhoneClick } from '../config/business';

export const MobileCTA = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const location = useLocation();
  const { contact } = businessConfig;

  // Hide on quote page to not obstruct the form
  const hideOnPaths = ['/quote', '/get-a-quote', '/admin'];
  const shouldHide = hideOnPaths.some(path => location.pathname.startsWith(path));

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      // Hide when scrolling down, show when scrolling up
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  if (shouldHide) return null;

  return (
    <div 
      className={`fixed bottom-0 left-0 right-0 z-40 lg:hidden transition-transform duration-300 ${
        isVisible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <div className="bg-gray-900 border-t border-gray-700 px-4 py-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] shadow-2xl">
        <div className="flex gap-3 max-w-md mx-auto">
          <a 
            href={contact.phoneLink}
            onClick={() => trackPhoneClick('Mobile Sticky - Call')}
            className="flex-1 flex items-center justify-center gap-2 bg-white text-gray-900 font-bold py-3 px-4 rounded-lg hover:bg-gray-100 transition-colors"
            data-phone-number="true"
          >
            <Phone className="w-5 h-5" />
            <span>Call</span>
          </a>
          <Link 
            to="/quote"
            className="flex-1 flex items-center justify-center gap-2 bg-yellow-500 text-gray-900 font-bold py-3 px-4 rounded-lg hover:bg-yellow-400 transition-colors"
          >
            <ArrowRight className="w-5 h-5" />
            <span>Get Quote</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MobileCTA;
